import React from 'react'
import { Button } from '../UI/index'
import { makeStyles } from '@material-ui/core/styles'
import Modal from '@material-ui/core/Modal'
import Backdrop from '@material-ui/core/Backdrop'
import Fade from '@material-ui/core/Fade'
import googleLogo from '../../assetss/img/googleLogo.jpg'
import closeModalIcon from '../../assetss/img/closeModalIcon.svg'

const useStyles = makeStyles(theme => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    borderRadius: 12,
    backgroundColor: '#ffffff',
    outline: 'none',
    width: '307px',
    height: '188px',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
  },
  title: {
    width: '240px',
    height: '56px',
    margin: '0 auto',
    marginTop: '39px',
    marginBottom: '16px',
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '20px',
    color: '#000000',
    textAlign: 'center',
  },
  banBtnBox: {
    display: 'flex',
    justifyContent: 'center',
  },
  btnMain: {
    width: '218px',
    height: '45px',
    border: 'none',
    color: 'rgba(0, 0, 0, 0.54)',
    backgroundColor: '#ffffff',
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '14px',
    borderRadius: '5px',
    boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.25)',
    '&:hover': {
      backgroundColor: '#ffffff',
    },
  },
  googleLogo: {
    width: '18px',
    height: '18px',
    marginRight: '24px',
  },
  closeIcon: {
    position: 'absolute',
    top: '12px',
    right: '12px',
    '&:hover': {
      cursor: 'pointer',
      opacity: '0.5',
    },
  },
}))

const LoginModal = ({ open, setOpen, onSignUp, textModal }) => {
  const classes = useStyles()
  const handleClose = () => setOpen(false)

  return (
    <div>
      <Modal
        aria-labelledby='transition-modal-title'
        aria-describedby='transition-modal-description'
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <div className={classes.title}>
              {textModal?.textTitle}
            </div>
            <div className={classes.banBtnBox}>
              <Button
                onClick={() => {
                  onSignUp()
                  handleClose()
                }}
                className={classes.btnMain}
              >
                <img className={classes.googleLogo} src={googleLogo} /> {textModal?.textBtn}
              </Button>
              <img onClick={handleClose} className={classes.closeIcon} src={closeModalIcon} />
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  )
}

export default LoginModal
